import Breadcrumb from "@/components/Breadcrumb/Breadcrumb";
import { MotifIcon } from "@ey-xd/motif-react";
import { IconoirArrowLeft } from "@ey-xd/motif-icon";
import DistributionSetupForm from "./DistributionSetupForm";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PageTitle from "@/components/Form/PageTitle/PageTitle";
import { useSelector } from "react-redux";
import { ActiveTabsOrder } from "@/menuData";

const DistributionSetupGrid = ({isDuplicate=false}:{isDuplicate: boolean}) => {
  const { caseId, distributionId } = useParams();
  const { t } = useTranslation();
      const { caseName } = useSelector((state: any) => state.case);
  
  const breadcrumbItems = [
    {
      label: "External Submission",
      value: "10 New Creditor Submission",
      elementKey: "submission",
      text: caseName,
      url: `/case/${caseId}/?activeTab=${ActiveTabsOrder.DISTRIBUTION}`,
      icon: <MotifIcon src={IconoirArrowLeft} />,
    },
    {
      label: "External Submission",
      value: "10 New Creditor Submission",
      elementKey: "submission",
      text: t("pages.distributions.distribution.addNewDistribution"),
      url: `/case/${caseId}/?activeTab=${ActiveTabsOrder.DISTRIBUTION}`,
      icon: <MotifIcon src={IconoirArrowLeft} />,
      disabled:true
    },
  ];
  return (
    <>
      <div className="pad-b-10">
        <Breadcrumb items={breadcrumbItems} ariaLabel="Breadcrumb navigation" />
      </div>
      <PageTitle
        title={t("pages.distributions.distribution.distributionSetup")}
      />
      <DistributionSetupForm isDuplicate={isDuplicate} distributionId={distributionId}/>
    </>
  );
};

export default DistributionSetupGrid;
